module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t('login.name8'),
      "visible": _vm.dialogFormVisible,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    ref: "changePasswordForm",
    attrs: {
      "model": _vm.changePasswordForm,
      "rules": _vm.changePasswordRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('login.name10') + '：',
      "prop": "oldPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": _vm.$t('placeholder.name03') + _vm.$t('login.name10')
    },
    model: {
      value: (_vm.changePasswordForm.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.changePasswordForm, "oldPassword", $$v)
      },
      expression: "changePasswordForm.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('login.name11') + '：',
      "prop": "newPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": _vm.$t('placeholder.name03') + _vm.$t('login.name11')
    },
    model: {
      value: (_vm.changePasswordForm.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.changePasswordForm, "newPassword", $$v)
      },
      expression: "changePasswordForm.newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('login.name12') + '：',
      "prop": "confirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": _vm.$t('placeholder.name03') + _vm.$t('login.name12')
    },
    model: {
      value: (_vm.changePasswordForm.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.changePasswordForm, "confirmPassword", $$v)
      },
      expression: "changePasswordForm.confirmPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('main.name07')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v(_vm._s(_vm.$t('main.name08')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edf7dcde"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/changePassword.vue
// module id = 553
// module chunks = 313